import { Services, getApi, getFetchOptions, getUrl, } from '@volkswagen-onehub/library-services-common';
export async function fetchDataversion(serviceConfig, mockConfig, tenant, ruleDate) {
    const queryParams = {
        tenant,
        ruleDate,
    };
    const url = getUrl(serviceConfig, mockConfig, '/tenantDataVersion', queryParams);
    return getApi(url, Services.VICCI_VCS_TENANT_DATA_VERSION, getFetchOptions(serviceConfig, mockConfig));
}
